import styled from "@emotion/styled";

const LayoutStyled = styled.div`
    font-family: "IBM Plex Sans", sans-serif;
`;

export const Layout = ({ children }) => {
    return <LayoutStyled>{children}</LayoutStyled>;
};
